import React from 'react';
//CSS
import styles from './LockIndicator.module.css';
//Components
//Data

type LockIndicatorProps = {
  lockedBy?: string;
};

const LockIndicator = ({ lockedBy } : LockIndicatorProps) => {
  return (
    <div className={styles.container}>
      <img className={styles.lockedIcon} src="/img/lock-small.svg" alt="Lock Icon" />
      <div className={styles.lockedText}>Currently being edited by {lockedBy ?? 'another user'}</div>
    </div>
  );
};

export default LockIndicator;